var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: {
        title: _vm.title,
        "close-on-click-modal": false,
        "append-to-body": "",
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          class: _vm.method === "view" ? "readonly" : "",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            rules: _vm.dataRule,
            disabled: _vm.method === "view",
            "label-width": "80px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.doSubmit()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "类型", prop: "type" } },
            [
              _c("el-input", {
                attrs: { maxlength: "50", placeholder: "类型" },
                model: {
                  value: _vm.inputForm.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.inputForm, "type", $$v)
                  },
                  expression: "inputForm.type",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "描述", prop: "remarks" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  maxlength: "50",
                  placeholder: "描述",
                },
                model: {
                  value: _vm.inputForm.remarks,
                  callback: function ($$v) {
                    _vm.$set(_vm.inputForm, "remarks", $$v)
                  },
                  expression: "inputForm.remarks",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _vm.method != "view"
            ? _c(
                "el-button",
                {
                  directives: [
                    { name: "noMoreClick", rawName: "v-noMoreClick" },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.doSubmit()
                    },
                  },
                },
                [_vm._v("确定")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }